<ng-container *adaptLoadingUntilFirstEmit="let processSteps of processSteps$">
    <adapt-display-guidance-material [guidanceMaterial]="guidanceMaterial"
                                     [showDescription]="false"></adapt-display-guidance-material>
    @if (processSteps.length > 0) {
        is used in the following role tasks:
        <div class="process-step-list">
            <ul>
                @for (processStep of processSteps; track processStep) {
                    <li>
                        <adapt-link-process-step [processStep]="processStep"></adapt-link-process-step>
                    </li>
                }
            </ul>
        </div>
    } @else {
        is not in use.
    }
</ng-container>
